
const INITIAL_STATE = {
    carregando: true,
    notificacoes: [],
    notificacaoSelecionada: null,
    qtdNaoLida: 0,
    navegacao: 'LISTAR_NOTIFICACOES',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'CARREGANDO_NOTIFICACOES':
            return { ...state, carregando: true };
            
        case 'CONSULTAR_NOTIFICACOES':
            return { ...state, carregando: false, notificacoes: action.payload.notificacoes, qtdNaoLida: action.payload.qtdNaoLida };

        case 'CONSULTAR_QUANTIDADE_NOTIFICACOES_NAO_LIDA':
            return { ...state, carregando: false, qtdNaoLida: action.payload.qtdNaoLida };

        case 'ERRO_CONSULTAR_NOTIFICACOES':
            return { ...state, carregando: false };

        case 'OPERACAO_REALIZADA_COM_SUCESSO':
            return { ...state, carregando: false };

        case 'OPERACAO_REALIZADA_COM_ERRO':
            return { ...state, carregando: false, notificacaoSelecionada: null, navegacao: 'LISTAR_NOTIFICACOES' };

        case 'DETALHAR_NOTIFICACAO':
            return { ...state, notificacaoSelecionada: action.payload.notificacaoSelecionada, navegacao: 'DETALHAR_NOTIFICACAO', qtdNaoLida: action.payload.qtdNaoLida };

        case 'LISTAR_NOTIFICACOES':
            return { ...state, notificacaoSelecionada: null, navegacao: 'LISTAR_NOTIFICACOES' }

        case 'VOLTAR_HOME':
            return { ...state, notificacaoSelecionada: null, qtdNaoLida: 0 }

        default:
            return state;
    }
}